import * as React from 'react';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

export class PortalFooter extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    const { userStore, portalStore, requestStore } = this.context;

    if (requestStore.requestData.isWebviewInApp) return null;
    if (requestStore.requestData.isInlineViewInWeb) return null;

    return (
      <div className="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
        {/*begin::Container*/}
        <div className="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
          {/*begin::Copyright*/}
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted font-weight-bold mr-2">2021©</span>
            <a href="/" target="_blank" className="text-dark-75 text-hover-primary">
              Schlaukopf
            </a>
          </div>
          {/*end::Copyright*/}
          {/*begin::Nav*/}
          <div className="nav nav-dark order-1 order-md-2">
            <a href="/info/faq" target="_blank" className="nav-link pr-3 pl-0">
              Häufige Fragen
            </a>
            <a href="/info/projekt" target="_blank" className="nav-link px-3">
              Projekt
            </a>
            <a href="/info/projekt" target="_blank" className="nav-link pl-3 pr-0">
              Impressum
            </a>
          </div>
          {/*end::Nav*/}
        </div>
        {/*end::Container*/}
      </div>
    );
  }
}
